<template>
  <b-tabs content-class="" nav-class="ml-1">
    <b-tab no-body :title="$t('views.excmmessages.list.messagesApproved')">
      <MessagesApprovedList/>
    </b-tab>
    <b-tab no-body :title="$t('views.excmmessages.list.messagesToApprove')">
      <MessagesToApproveList/>
    </b-tab>
  </b-tabs>
</template>

<script>
import { checkPagePermission } from '@/utils/checkRoles.js'
import MessagesApprovedList from '@/components/Dashboard/Views/excmmessage/MessagesApprovedList.vue'
import MessagesToApproveList from '@/components/Dashboard/Views/excmmessage/MessagesToApproveList.vue'

export default {
  components: {
    MessagesToApproveList,
    MessagesApprovedList
  },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMMessageList')
  }
}
</script>
